import React, { useEffect, useState } from "react";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import { backend, producturl } from "../../../../path";
import { Link, useNavigate, useParams } from "react-router-dom";
import Loader from "../../../layout/header/loader";
import { ToastContainer, toast } from "react-toastify";
import LoaderMain from "../../../layout/header/loader_sub";
import ScrollToTop from "../../../components/whatsapp connect";
import { Rating } from "@mui/material";
import { Helmet } from "react-helmet";
import styled from "styled-components";
import StarIcon from "@mui/icons-material/Star";

function SubCategoryListingMainNew(props) {
  const navigate = useNavigate();
  const [isFilter, setIsFilter] = useState(false);
  const [loading, setLoading] = useState();
  const [error, setError] = useState();
  const [data, setData] = useState([]);
  const [fullData, setFullData] = useState([]);
  const [authenticated, setAuthenticated] = useState(
    JSON.parse(localStorage.getItem("userdata"))
  );

  const { id } = useParams();

  const [currentPage, setCurrentPage] = useState(1);
  const productsPerPage = 12;

  const handleAddToWishList = async (id) => {
    if (authenticated === null) {
      if (typeof window.openAuthModal === "function") {
        window.openAuthModal("login");
      } else {
        navigate("/login");
      }
      return;
    }

    const formData = {
      status: 0,
      product_id: id,
    };

    try {
      const response = await fetch(backend + "addtowishlistuserside", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authenticated?.access_token}`,
        },
        body: JSON.stringify(formData),
      });

      if (response.status === 200) {
        toast.success("Item added to wishlist", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        props.setWishChange(!props.wishChange);
        await new Promise((resolve) => setTimeout(resolve, 3000));
        // navigate("/cart");
      } else if (response.status === 409) {
        toast.error("Conflict occurred. Please try again later.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else if (response.status === 401) {
        toast.error("Item already exits in the wishlist", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
      }
    } catch (error) {}
  };

  useEffect(() => {
    fetchData();
  }, [id, currentPage]);

  const fetchData = () => {
    setLoading(true);
    setError(null);

    const startIndex = (currentPage - 1) * productsPerPage;
    const endIndex = startIndex + productsPerPage;

    fetch(
      backend +
        `getproductbysubcategoryiduserside/${id}?min=${priceRange[0]}&max=${priceRange[1]}`,
      {
        method: "GET",
      }
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        setFullData(data);
        // Assuming data is an array of products
        const products = data.slice(startIndex, endIndex);
        setData(products);
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    // Scroll to the top of the page whenever a new page is rendered
    window.scrollTo(0, 0);
  }, [fetchData]);

  const handleFilter = () => {
    setIsFilter((prevIsFilter) => !prevIsFilter);
    fetchData();
  };
  const handleProductRoute = (productId) => {
    navigate(`/product/${productId}`);
    // window.location.reload();
  };
  const [priceRange, setPriceRange] = useState([1, 50000]);

  const handlePriceChange = (value) => {
    setPriceRange(value);
  };

  const handleAddCart = async (id) => {
    if (authenticated === null) {
      if (typeof window.openAuthModal === "function") {
        window.openAuthModal("login");
      } else {
        navigate("/login");
      }
      return;
    }

    const formData = {
      status: 1,
      quantity: 1,
      product_id: id,
    };

    try {
      const response = await fetch(backend + "addtocartuserside", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${authenticated?.access_token}`,
        },
        body: JSON.stringify(formData),
      });

      if (response.status === 200) {
        toast.success("Item added to cart", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        props.setCartChange(!props.cartChange);
        await new Promise((resolve) => setTimeout(resolve, 3000));
        // navigate("/cart");
      } else if (response.status === 409) {
        toast.error("Conflict occurred. Please try again later.", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else if (response.status === 401) {
        toast.error("Item already exits in the cart", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
      }
    } catch (error) {}
  };
  const decodeHTML = (html) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

  return (
    <>
      <ToastContainer />
      <Helmet>
        <title>{data[0]?.sub_category_seo}</title>
        <meta
          name="description"
          content={data[0]?.sub_category_meta_description}
        />
        <meta name="keywords" content={data[0]?.sub_category_meta_keyword} />
      </Helmet>
      <Main>
        <div className="page-header breadcrumb-wrap">
          <div className="container-fluid">
            <div className="breadcrumb">
              <div className="breadcrumb-item d-inline-block">
                <Link to="/" title="Home">
                  Home
                </Link>
              </div>
              <span></span>
              <div className="breadcrumb-item d-inline-block">
                <Link to="/product-list" title="Products">
                  {data[0]?.category_name}
                </Link>
              </div>
              <span></span>
              <div className="breadcrumb-item d-inline-block active">
                <div itemProp="item">
                  {data[0]?.sub_category_name
                    ? data[0]?.sub_category_name
                    : "Sub Category"}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid mb-30">
          <div className="row">
            <div className="col-lg-12 m-auto mt-4 d-none d-md-block d-lg-block">
              <Div>
                <div></div>
                <div>
                  {data[0]?.sub_category_description && (
                    <Header>
                      <H2
                        dangerouslySetInnerHTML={{
                          __html: decodeHTML(data[0]?.sub_category_description),
                        }}
                      ></H2>
                    </Header>
                  )}
                </div>
                <FilterMenu>
                  <Link
                    className="shop-filter-toggle mb-0"
                    style={{ height: "40px" }}
                  >
                    <span className="title font-jost font-normal text-[20px] leading-[100%] tracking-[0] flex items-center">
                      <div className="text-[#187837] me-1">
                        {fullData?.length}
                      </div>{" "}
                      Items
                    </span>
                  </Link>
                </FilterMenu>
              </Div>
            </div>
          </div>
          <div className="mt-4">
            <div className="products-listing position-relative">
              <div className="list-content-loading">
                <div className="half-circle-spinner">
                  <div className="circle circle-1"></div>
                  <div className="circle circle-2"></div>
                </div>
              </div>
              <input type="hidden" name="page" data-value="1" />
              <input type="hidden" value="" />
              <input type="hidden" name="num" value="" />
              <input type="hidden" name="q" value="" />

              <div className="">
                <div className="row">
                  {/* Left Sidebar Filter */}
                  <div className="col-lg-2 col-md-3 col-12 mb-4">
                    <div className="p-4 bg-white mb-4">
                      <h3 className="text-lg font-semibold mb-4 border-b border-indigo-500">
                        Filter
                      </h3>

                      {/* Category Filter */}
                      <div className="mb-4">
                        <h4 className="text-base font-medium mb-2">
                          By Categories
                        </h4>
                        <div className="flex flex-col space-y-2">
                          <label className="flex items-center space-x-2">
                            <input
                              type="checkbox"
                              className="form-check-input"
                            />
                            <span>Handloom</span>
                          </label>
                          <label className="flex items-center space-x-2">
                            <input
                              type="checkbox"
                              className="form-check-input"
                            />
                            <span>Other</span>
                          </label>
                        </div>
                      </div>

                      {/* Sort By */}
                      <div className="mb-4">
                        <h4 className="text-base font-medium mb-2">Sort By</h4>
                        <div className="flex flex-col space-y-2">
                          <label className="flex items-center space-x-2">
                            <input
                              type="radio"
                              name="sort"
                              className="form-check-input"
                            />
                            <span>Popularity</span>
                          </label>
                          <label className="flex items-center space-x-2">
                            <input
                              type="radio"
                              name="sort"
                              className="form-check-input"
                            />
                            <span>Low to High</span>
                          </label>
                          <label className="flex items-center space-x-2">
                            <input
                              type="radio"
                              name="sort"
                              className="form-check-input"
                            />
                            <span>High to Low</span>
                          </label>
                        </div>
                      </div>

                      {/* Price Range */}
                      <div className="mb-4">
                        <h4 className="text-base font-medium mb-2">By Price</h4>
                        <div className="price-filter-inner">
                          <Slider
                            range
                            min={1}
                            max={50000}
                            value={priceRange}
                            onChange={handlePriceChange}
                          />
                          <input
                            type="hidden"
                            className="min_price min-range"
                            name="min_price"
                            value={priceRange[0]}
                            data-label="Min price"
                          />
                          <input
                            type="hidden"
                            className="min_price max-range"
                            name="max_price"
                            value={priceRange[1]}
                            data-label="Max price"
                          />
                          <div className="price_slider_amount">
                            <div className="label-input">
                              <span className="d-inline-block">
                                Range : &nbsp;
                              </span>
                              <span className="from d-inline-block">
                                {priceRange[0]}
                              </span>{" "}
                              -
                              <span className="to d-inline-block">
                                {priceRange[1]}
                              </span>
                            </div>
                          </div>
                        </div>
                        <button
                          className="w-full mt-3 bg-green-600 hover:bg-green-700 text-white py-2 rounded-lg"
                          onClick={handleFilter}
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                    {/* Ads Box */}
                    <div className="p-4 border rounded-lg shadow-sm bg-white h-64 flex items-center justify-center">
                      <span className="text-gray-500">Ad Space</span>
                    </div>
                  </div>

                  {/* Right Side Product Grid */}
                  <div className="col-lg-10 col-md-9 col-12">
                    <div className="row product-grid">
                      {loading && (
                        <div>
                          {/* Loading...  */}
                          <LoaderMain />
                        </div>
                      )}

                      {!loading &&
                        data.map((item, i) => (
                          <div
                            key={i}
                            className="col-xxl-3 col-xl-3 col-lg-4 col-md-4 col-12 col-sm-6 "
                          >
                            <div
                              className="product-cart-wrap mb-30 wow animate__animated animate__fadeIn border-0 rounded-none"
                              data-wow-delay="0.1s"
                            >
                              <div className="product-img-action-wrap border border-1 rounded-lg">
                                <div className="product-img product-img-zoom">
                                  <Link
                                    to={`/product/${item.product_slug}`}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleProductRoute(item.product_slug);
                                    }}
                                  >
                                    <img
                                      className="default-img"
                                      style={{
                                        height: "320px",
                                        width: "100%",
                                        objectFit: "contain",
                                        objectPosition: "center",
                                      }}
                                      src={producturl + item.thumbnail}
                                      alt={item.product_name}
                                    />
                                    <img
                                      className="hover-img"
                                      style={{
                                        height: "320px",
                                        width: "100%",
                                        objectFit: "contain",
                                        objectPosition: "center",
                                      }}
                                      src={
                                        item.thumbnail2
                                          ? producturl + item.thumbnail2
                                          : producturl + item.thumbnail
                                      }
                                      alt={item.product_name}
                                    />
                                  </Link>
                                </div>

                                <div className="product-badges product-badges-position product-badges-mrg">
                                  <RatingBox>
                                    <span
                                      style={{
                                        fontSize: "12px",
                                        color: "#fff",
                                      }}
                                    >
                                      {item.average_stars || "4"}
                                    </span>
                                    <StarIcon
                                      style={{
                                        fontSize: "12px",
                                        color: "#fff",
                                      }}
                                    />
                                  </RatingBox>
                                </div>
                                <div className="product-badges product-badges-position-right product-badges-mrg cursor-pointer">
                                  <LikeBox
                                    onClick={() =>
                                      handleAddToWishList(item.product_id)
                                    }
                                  >
                                    <img
                                      src="/storage/general/Icon.svg"
                                      alt="wish"
                                    />
                                  </LikeBox>
                                </div>
                              </div>
                              <ProductBottom className="product-content-wrap p-0">
                                <h2 className="text-truncate">
                                  <Link
                                    to={`/product/${item.product_slug}`}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      handleProductRoute(item.product_slug);
                                    }}
                                    title={item.product_name}
                                  >
                                    {item?.product_name}
                                  </Link>
                                </h2>

                                <div className="text-truncate">
                                  <span className="font-poppins font-medium text-[12px] leading-[100%] tracking-[0] text-[#7F7F7F]">
                                    {/* Sold By{" "} */}
                                    <Link
                                      to={`/product/${item.product_slug}`}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleProductRoute(item.product_slug);
                                      }}
                                    >
                                      {item?.vendor_name ?? "Kerala Special"}
                                    </Link>
                                  </span>
                                </div>
                                <div className="product-card-bottom">
                                  <div className="flex items-baseline py-3">
                                    <span className="text-[24px] font-medium text-gray-900 leading-[100%] font-[Poppins] color-rgba(0, 0, 0, 1)">
                                      ₹{item.sale_price}/-
                                    </span>
                                    {item.mrp && (
                                      <span className="font-poppins font-light italic text-[14px] leading-none line-through text-[#db0f0f] ps-4">
                                        {item.mrp}
                                      </span>
                                    )}
                                  </div>
                                  {/* <div className="add-cart"> */}
                                  <button
                                    onClick={() =>
                                      handleAddCart(item.product_id)
                                    }
                                    className={`
                            w-full max-w-[126px] h-[38px] flex items-center justify-center gap-[11px] rounded-[10px] 
                            font-poppins font-medium text-xs leading-none tracking-normal cursor-pointer opacity-100 
                            transition-all duration-300 border-1 border-[#187837] hover:bg-[#187837] hover:text-white
                            
                          `}
                                  >
                                    Add to Cart
                                  </button>
                                </div>
                                {/* </div> */}
                              </ProductBottom>
                            </div>
                          </div>
                        ))}

                      {/* Pagination controls */}
                      <div className="flex items-center justify-center gap-2 mt-6">
                        {/* Prev Button */}
                        <button
                          type="button"
                          onClick={() =>
                            setCurrentPage((prevPage) =>
                              Math.max(prevPage - 1, 1)
                            )
                          }
                          disabled={currentPage === 1}
                          className={`px-4 py-2 rounded-xl border text-sm font-medium transition ${
                            currentPage === 1
                              ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                              : "border-green-600 text-green-600 hover:bg-green-600 hover:text-white"
                          }`}
                        >
                          Prev
                        </button>

                        {/* Current Page */}
                        <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-green-600 text-white text-sm font-medium">
                          {currentPage}
                        </span>

                        {/* Next Button */}
                        <button
                          type="button"
                          onClick={() =>
                            setCurrentPage((prevPage) => prevPage + 1)
                          }
                          disabled={data.length < productsPerPage}
                          className={`px-4 py-2 rounded-xl border text-sm font-medium transition ${
                            data.length < productsPerPage
                              ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                              : "border-green-600 text-green-600 hover:bg-green-600 hover:text-white"
                          }`}
                        >
                          Next
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <ScrollToTop />
      </Main>
    </>
  );
}
export default SubCategoryListingMainNew;
const Main = styled.main`
  // padding-top: 192px;
`;
const Header = styled.div`
  p {
    font-size: 35px;
    line-height: 1.2;
    font-weight: 500;
    padding: 20px 0;
    @media screen and (max-width: 640px) {
      font-size: 25px;
    }
  }
`;
const H2 = styled.h2``;
const Div = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const FilterMenu = styled.div`
  position: relative;
`;
const FilterDropdown = styled.div`
  display: none;
  position: absolute;
  right: 0;
  top: calc(100% + 20px);
  z-index: 9;
  min-width: 600px;
  background-color: #fff;
  border: 1px solid #0000002e;
  border-radius: 10px;
  padding-top: 20px;
  &.active {
    display: block;
  }
  @media screen and (max-width: 680px) {
    min-width: 300px;
  }
  @media screen and (max-width: 320px) {
    min-width: 270px;
  }
`;
const FilterBtn = styled.button`
  width: 100%;
  display: flex;
  justify-content: end;
  background-color: transparent;
  border: none;
  margin: 20px 0;
`;
const ProductBottom = styled.div`
  padding: 20px 10px;
  // background-color: #f8f8f8;
  a {
    color: #000;
  }
  h2 {
    text-wrap: auto;
    margin: 10px 0;
    min-height: 50px;
    a {
      font-weight: 500;
      font-size: 20px;
    }
  }
`;
const RatingBox = styled.div`
  position: absolute;
  top: 10px;
  left: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 24px;
  border-radius: 4px;
  gap: 2px;
  padding: 0 8px;
  background-color: rgba(24, 120, 55, 1); /* Or any background */
  font-size: 12px;
  font-weight: 500;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  z-index: 2;
`;
const LikeBox = styled.div`
  position: absolute;
  top: 10px;
  right: 7px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 24px;

  z-index: 2;
`;
